module.exports = __webpack_public_path__ + "static/media/pattern-bg.8d3f4ad6.png";